import React from 'react'

function Checkbox({ id, checked, onChange}) {


    return (
        <label className="relative flex cursor-pointer items-center rounded mt-0.5 mr-1 md:mr-2">

            <input
                checked={checked}
                onChange={onChange}
                id={id}
                type="checkbox" className="peer cursor-pointer appearance-none relative h-[15px] w-[15px] md:h-[17px] md:w-[17px] bg-white dark:bg-gray-100/25 border border-gray-300 dark:border-gray-100 transition-all checked:bg-headPrimary rounded"
            />

            <div className="pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 transition-opacity peer-checked:opacity-100">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-2.5 w-2.5 md:h-3.5 md:w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="1">
                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                </svg>
            </div>

        </label>
    )
}

export default Checkbox